import request from '@/utils/request'

export function getStickerPanel() {
  return request({
    url: '/v1/sticker/panel',
    method: 'get'
  })
}

export function addSticker(data) {
  return request({
    url: '/v1/sticker',
    method: 'post',
    data
  })
}

export function deleteSticker(id) {
  return request({
    url: `/v1/sticker/${id}`,
    method: 'delete'
  })
}

export function pinStickerFront(id) {
  return request({
    url: `/v1/sticker/${id}/front`,
    method: 'put'
  })
}
